import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import EmptyListing from 'src/components/EmptyListing';
import AdvicesListing from 'src/components/AdvicesListing';
import PaginationWrapper from 'src/components/Pagination/PaginationWrapper';
import advice from 'src/types/advice';


const AdvicesContainer = ({ advices, activeCategory, advicesURL }) => {
  const { name, path } = activeCategory;

  return (
    <PaginationWrapper activeTab={ name }>
      {
        // eslint-disable-next-line multiline-ternary
        advices.length > 0
          ? <AdvicesListing advices={ advices } advicesURL={ advicesURL } categoryPath={ path } /> : <EmptyListing />
      }
    </PaginationWrapper>
  );
};

AdvicesContainer.propTypes = {
  activeCategory: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired,
  advices: PropTypes.arrayOf(
    PropTypes.shape(advice)
  ).isRequired,
  advicesURL: PropTypes.string.isRequired
};


const mapStateToProperties = state => ({
  advicesURL: state.configReducer.advicesURL,
  advices: state.advicesReducer.advices,
  activeCategory: state.categoriesReducer.categories
    .filter(category => category.id === state.tabsReducer.activeTab)
    .shift()
});

export { AdvicesContainer };

export default connect(mapStateToProperties)(AdvicesContainer);
